<template>
    <div class="main">
        <Transition appear name="fade">
            <HeaderComponent
                    style="margin-top:100px;"
                    :text="$t('text.register_user')"
                    backgroundColor="#fff"
                />
        </Transition>
        <Transition appear name="fade">        
            
        </Transition>
            
        <Transition appear name="fade">
            <div class="body-container">
                
                <div v-if="loading" class="loader-container" style="text-align: center; margin-top:80px;">
                    <b-spinner
                        variant="dark"
                        label="Spinning"
                        class="login-loader"
                    ></b-spinner>
                </div>
                <b-form @submit="onSubmit" v-if="!loading">
                    <b-form-group id="input-group-0" :label="$t('text.email_address')" label-for="input-0">
                        <b-form-input
                        id="input-0"
                        v-model="form.email"
                        type="email"
                        :placeholder="$t('text.enter_email')"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-1" :label="$t('text.first_name')" label-for="input-1">
                        <b-form-input
                        id="input-1"
                        v-model="form.first_name"
                        :placeholder="$t('text.enter_first_name')"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-2" :label="$t('text.last_name')" label-for="input-2">
                        <b-form-input
                        id="input-2"
                        v-model="form.last_name"
                        :placeholder="$t('text.enter_last_name')"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-4" :label="$t('text.phone')" label-for="input-4">
                        <b-form-input
                        id="input-4"
                        v-model="form.phone"
                        type="number"
                        :placeholder="$t('text.enter_phone')"
                        required
                        ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group id="input-group-5" :label="$t('text.password')" label-for="input-4">
                        <b-form-input
                        id="input-5"
                        v-model="form.password"
                        type="password"
                        :placeholder="$t('text.enter_password')"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-6" :label="$t('text.repeat_password')" label-for="input-4">
                        <b-form-input
                        id="input-6"
                        v-model="form.repeat_password"
                        type="password"
                        :placeholder="$t('text.repeat_password')"
                        ></b-form-input>
                        <b-form-invalid-feedback :state="passwordValidation">
                            {{ $t('text.passwords_not_match') }}
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group id="input-group-7" label-for="input-7">
                        <b-form-checkbox v-model="form.terms_accepted" required>
                            <p style="font-size:12px;">{{ $t('text.terms_of_condition') }}</p>
                        </b-form-checkbox>
                    </b-form-group>

                    <b-button :disabled="!enableSubmitButton" type="submit" variant="primary">{{ $t('text.register_user') }}</b-button>
                    <a style="float:right" @click="$router.push('/login')" class="link-button">{{ $t('text.login') }}</a>
                </b-form>
            </div>
        </Transition>
    </div>
</template>

<script>
import HeaderComponent from "../components/HeaderComponent.vue";
import UserApiService from "../../services/user_api_service";

export default {
    name: "RegisterPage",
    components: {
        HeaderComponent,
    },
    data() {
        return {
            loading: false,
            form: {
                username: '',
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                password: '',
                repeat_password: '',
                terms_accepted: false
            },
        };
    },
    computed: {
        enableSubmitButton() {
            return (
                this.passwordValidation &&
                this.form.terms_accepted &&
                this.form.first_name &&
                this.form.last_name &&
                this.form.email &&
                this.form.phone &&
                this.form.password &&
                this.form.repeat_password &&
                this.form.password == this.form.repeat_password
            );
        },
        passwordValidation() {
            return (this.form.password == this.form.repeat_password) 
        }
    },
    methods: {
        async createUser() {
            this.loading = true;
            this.form.email = this.form.email.replaceAll(" ", "").toLowerCase()
            this.form.username = this.form.email
            var payload = this.form
            try {
                await UserApiService.post(payload);
                this.loading = false;
                if (this.$route.query.redirect) {
                    this.$router.push({name: "login", query: { redirect: this.$route.query.redirect }});
                } else {
                    this.$router.push("/login");
                }
                
            } catch (error) {
                this.$bvModal.msgBoxOk(error.response.data[0], {okVariant: 'danger'})
                localStorage.clear();
                this.loading = false;
            }
        },
        logout: function() {
            this.$store.dispatch("logout").then(() => {
                this.$router.push("/");
            });
        },
        onSubmit(event) {
            event.preventDefault()
            if (this.passwordValidation && this.form.terms_accepted) {
                this.createUser()
            }
        },
        makeToast(variant = null, title, body) {
            this.$bvToast.toast(body, {
                title: title,
                toaster: "b-toaster-top-center",
                variant: variant,
                solid: true
            });
        },
    },
};
</script>

<style scoped>
.main {
  height: 100%;
  background-color: #fff;
}

.body-container {
    text-align: left;
    margin: auto;

    padding-bottom: 100px;
    padding-left: 30px;
    padding-right: 30px;

    max-width: 860px;
}

.submit-button {
    float:right;
}

.link-button {
    color: #007bff;
}
</style>
